import { gsap } from 'gsap';
import onResizeDebounced from '../util/onResizeDebounced';

export default class NewFaq {
  constructor() {
    this.selector = 'b-af-faq';

    this.classnames = {
      blockLoaded: 'b-af-faq--loaded',
      item: 'b-af-faq__item',
      itemActive: 'b-af-faq__item--active',
      itemHead: 'b-af-faq__item-head',
      itemBody: 'b-af-faq__item-body',
      itemIcon: 'b-af-faq__item-icon',
      itemTitle: 'b-af-faq__item-title',
      itemText: 'b-af-faq__item-text',
    };

    this.blocks = Array.from(document.querySelectorAll(`.${this.selector}`));

    if (this.blocks.length === 0) return;

    this.init();
  }

  init() {
    this.blocks.forEach((block) => {
      this.initAccordion({ block });
    });
  }

  initAccordion({ block }) {
    const items = Array.from(block.querySelectorAll(`.${this.classnames.item}`));

    if (items.length === 0) {
      this.showAllItems({ items });
      return;
    }

    this.handleBlockLoad({ block });

    this.handleAccordionItemBodyHeightOnResize({ items });

    items.forEach((item) => {
      const itemHead = item.querySelector(`.${this.classnames.itemHead}`);
      const itemBody = item.querySelector(`.${this.classnames.itemBody}`);

      this.setItemItemBodyHeight({ item, itemBodyHeight: this.getItemBodyHeight({ itemBody }) });

      if (!item.classList.contains(this.classnames.itemActive)) {
        this.initialHideItemBody({ itemBody });
      }

      itemHead.addEventListener('click', () => {
        this.closeOtherOpenItems({ items: items.filter((i) => i !== item) });
        this.toggleItem({ item, itemBody });
      });
    });
  }

  handleAccordionItemBodyHeightOnResize({ items }) {
    onResizeDebounced(() => {
      items.forEach((item) => {
        const itemBody = item.querySelector(`.${this.classnames.itemBody}`);

        if (!itemBody) {
          return;
        }

        gsap.set(itemBody, {
          height: 'auto',
        });

        this.setItemItemBodyHeight({ item, itemBodyHeight: this.getItemBodyHeight({ itemBody }) });

        if (!item.classList.contains(this.classnames.itemActive)) {
          this.initialHideItemBody({ itemBody });
        }
      });
    }, 300);
  }

  closeOtherOpenItems({ items }) {
    console.log(items);

    items.forEach((item) => {
      const itemBody = item.querySelector(`.${this.classnames.itemBody}`);

      if (!itemBody) {
        return;
      }

      this.slideHideItemBody({ itemBody });
      item.classList.remove(this.classnames.itemActive);
    });
  }

  toggleItem({ item, itemBody }) {
    item.classList.toggle(this.classnames.itemActive);

    if (item.classList.contains(this.classnames.itemActive)) {
      this.slideShowItemBody({ itemBody });
    } else {
      this.slideHideItemBody({ itemBody });
    }
  }

  handleBlockLoad({ block }) {
    block.classList.add(this.classnames.blockLoaded);
  }

  showAllItems({ items }) {
    items.forEach((item) => {
      item.classList.add(this.classnames.itemActive);
    });
  }

  initialHideItemBody({ itemBody }) {
    if (!itemBody) {
      return;
    }

    gsap.set(itemBody, {
      height: 0,
    });
  }

  slideHideItemBody({ itemBody }) {
    if (!itemBody) {
      return;
    }

    gsap.to(itemBody, {
      height: 0,
      duration: 0.5,
    });
  }

  slideShowItemBody({ itemBody }) {
    if (!itemBody) {
      return;
    }

    gsap.to(itemBody, {
      height: itemBody.scrollHeight,
      duration: 0.5,
    });
  }

  getItemBodyHeight({ itemBody }) {
    if (!itemBody) {
      return '0';
    }

    return itemBody.scrollHeight;
  }

  setItemItemBodyHeight({ item, itemBodyHeight }) {
    item.style.setProperty('--item-body-height', `${itemBodyHeight}px`);
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/newFaq.js